import React from "react";
import { Grid, styled } from "@mui/material";
import HomeHero from "../components/home/HomeHero";
import Ambitions from "../components/home/Ambitions";
import EnlargeKnowledge from "../components/home/EnlargeKnowledge";
import FindSupport from "../components/home/FindSupport";
import SubscribeNow from "../components/home/SubscribeNow";
import DevelopAlliances from "../components/home/DevelopAlliances";
import JoinUs from "../components/home/JoinUs";
import StayInformed from "../components/home/StayInformed";
import Socials from "../components/home/Socials";
import Podcasts from "../components/home/Podcasts"
import SmartsuppChat from "../components/tracking/SmartsuppChat";
import {useIsLoggedIn, useIsSubscribed} from "../hooks/auth";

export const CenteredSiteBlock = styled(Grid)(({ theme }) => {
  return {
    maxWidth: "1440px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
});

const Home = () => {
  const isSubscribed = useIsSubscribed();

  return (
    <Grid
      container
      sx={{
        background: "white",
        width: "100%",
        minWidth: "100%",
        overflow: "hidden",
      }}
    >
      <HomeHero />
      <Ambitions />
      <EnlargeKnowledge />
      <FindSupport />
      <SubscribeNow />
      <DevelopAlliances />
      <JoinUs />
      <Podcasts />
      {/*<Magazine />*/}
      <StayInformed />
      <Socials />
      <SmartsuppChat />
    </Grid>
  );
};

export default Home;
